import UseCase from "./marketing/UseCase";

export default function UseCaseConsultants() {
  return (
    <UseCase
      path="/for/consultants"
      seoTitle="NFC business cards for consultants — WhoBrew"
      seoDescription="A digital business card for independent consultants and boutique firms. Engagement deck, case studies, intake form, and calendar in one link."
      eyebrow="For consultants"
      headline="A card that closes the engagement after the room empties."
      italicWord="closes"
      subhead={`One link with your engagement deck, your two best case studies, your intake form, and your calendar. The conversation continues without a single LinkedIn DM saying "can you send me your deck?"`}
      preview={{ name: "Sean Thomas", title: "Independent Strategy Consultant", handle: "seanthomas" }}
      linkExamples={[
        { label: "Engagement deck" },
        { label: "Case studies" },
        { label: "Intake form" },
        { label: "Calendar" },
        { label: "LinkedIn" },
        { label: "Hourly rates" },
        { label: "Substack" },
        { label: "Industry whitepaper" },
      ]}
      features={[
        {
          title: "The deck without the email chain.",
          body: "Replace the deck file by uploading a new version; the card link stays the same. Prospects always see your latest engagement framework, not what you happened to send three quarters ago.",
        },
        {
          title: "An intake form that pre-qualifies.",
          body: "Ask the questions you'd ask in the first twenty minutes of a discovery call before the call gets booked. Filter out misaligned engagements without spending the hour.",
        },
        {
          title: "Calendar bookings tied to the right scope.",
          body: "Run multiple Calendly event types and link the right one based on the prospect's intake form answers. Discovery, scoping, or execution kickoff, depending on where they actually are.",
        },
      ]}
      steps={[
        {
          title: "Build the card with your deck, case studies, and intake form.",
          body: "Drop in the latest engagement deck, your two strongest case studies, your intake form, and your calendar. Five minutes.",
        },
        {
          title: "Hand it out at every event, panel, and intro call.",
          body: "Order an NFC card. Tap it at conferences and panel events. Drop the QR in your speaker slides. Add the URL to your email signature.",
        },
        {
          title: "Read what people clicked before the call.",
          body: "Check Insights before each booked call. Knowing whether the prospect viewed your case studies vs. just your hourly rates changes how the conversation should open.",
        },
      ]}
      faq={[
        {
          q: "How does this fit with my own website?",
          a: "WhoBrew complements a site, it doesn't replace one. Your card is the in-person artifact and the email-signature link; your site is the long-form portfolio. Most consultants link the card to the site and the site to the card.",
        },
        {
          q: "Can I gate the engagement deck behind an email?",
          a: "Yes. Set the deck link to require an email address before download. The capture lands in Leads, source-tagged so you know it came from the card.",
        },
        {
          q: "What if I work across multiple practice areas?",
          a: "Pro accounts get up to three cards, so you can run a separate card per practice area. Each gets its own URL, its own deck, and its own analytics.",
        },
        {
          q: "Can I see who specifically opened my card?",
          a: "Insights show counts and shapes, not personal identifiers, by design. If a prospect fills out the intake form, you see the form data. Otherwise the card respects browsing privacy.",
        },
      ]}
    />
  );
}
